import { message } from 'antd';
import { createApi } from '@reduxjs/toolkit/query/react';
import baseQueryWith409 from './baseQueryWith409';
import qs from 'qs';
import fetch from 'auth/FetchInterceptor';

// direct fetch without RTK Query
export const getEntrevistasSico = query =>
	fetch.get(
		`/entrevistas-sico${
			query
				? `?${qs.stringify(
						{ ...query, publicationState: 'live' },
						{
							encodeValuesOnly: true,
						}
				  )}`
				: ''
		}`
	);
export const getEntrevistaSico = ({ id, query }) =>
	fetch.get(
		`/entrevistas-sico/${id}${
			query
				? `?${qs.stringify(
						{ ...query, publicationState: 'live' },
						{
							encodeValuesOnly: true,
						}
				  )}`
				: ''
		}`
	);
export const addEntrevistaSico = data => fetch.post('/entrevistas-sico', data);
export const updateEntrevistaSico = ({ id, ...data }) =>
	fetch.put(`/entrevistas-sico/${id}`, data);
export const deleteEntrevistaSico = id =>
	fetch.delete(`/entrevistas-sico/${id}`);

// RTK Query
export const entrevistasSicoApi = createApi({
	reducerPath: 'entrevistasSicoApi',
	baseQuery: baseQueryWith409,

	// default configuration
	refetchOnReconnect: true,
	refetchOnMountOrArgChange: true,
	refetchOnFocus: true,

	//endpoints
	endpoints: build => ({
		getEntrevistasSico: build.query({
			query: query => {
				return {
					url: `/entrevistas-sico${
						query
							? `?${qs.stringify(
									{ ...query, publicationState: 'live' },
									{
										encodeValuesOnly: true,
									}
							  )}`
							: ''
					}`,
					method: 'GET',
				};
			},
			transformResponse: response => response.data,
			providesTags: result =>
				// is result available?
				result
					? // successful query
					  [
							...result.map(({ id }) => ({
								type: 'EntrevistasSico',
								id,
							})),
							{ type: 'EntrevistasSico', id: 'LIST' },
					  ]
					: // an error occurred, but we still want to refetch this query when `{ type: 'Posts', id: 'LIST' }` is invalidated
					  [{ type: 'EntrevistasSico', id: 'LIST' }],
		}),
		getEntrevistaSico: build.query({
			query: ({ id, query }) => {
				return {
					url: `/entrevistas-sico/${id}${
						query
							? `?${qs.stringify(
									{ ...query, publicationState: 'live' },
									{
										encodeValuesOnly: true,
									}
							  )}`
							: ''
					}`,
					method: 'GET',
				};
			},
			transformResponse: response => response.data,
			providesTags: (result, error, id) => [{ type: 'EntrevistasSico', id }],
		}),
		addEntrevistaSico: build.mutation({
			query: data => {
				const user = JSON.parse(localStorage.getItem('me'));
				return {
					url: `/entrevistas-sico`,
					method: 'POST',
					body: JSON.stringify({
						data: {
							...data,
							created_by_user: user.id,
						},
					}),
				};
			},
			onQueryStarted: async (arg, { dispatch, queryFulfilled }) => {
				// try catch with antd message when fulfilled and rejected
				try {
					await queryFulfilled;
					message.success('Entrevista Sicológica agregado exitosamente');
				} catch (error) {
					message.error('Error al agregar entrevista sicológica');
					if (error.error.data?.error) {
						message.error(error.error.data?.error.message);
					}
				}
			},
			invalidatesTags: [{ type: 'EntrevistasSico', id: 'LIST' }],
		}),
		updateEntrevistaSico: build.mutation({
			query: ({ id, ...data }) => {
				const user = JSON.parse(localStorage.getItem('me'));
				return {
					url: `/entrevistas-sico/${id}`,
					method: 'PUT',
					body: JSON.stringify({
						data: {
							...data,
							updated_by_user: user.id,
						},
					}),
				};
			},
			onQueryStarted: async (arg, { dispatch, queryFulfilled }) => {
				// try catch with antd message when fulfilled and rejected
				try {
					await queryFulfilled;
					message.success(
						'Entrevista Sicológica actualizado exitosamente'
					);
				} catch (error) {
					message.error('Error al actualizar entrevista sicológica');
					if (error.error.data?.error) {
						message.error(error.error.data?.error.message);
					}
				}
			},
			invalidatesTags: (result, error, { id }) => [
				{ type: 'EntrevistasSico', id },
			],
		}),
		deleteEntrevistaSico: build.mutation({
			query: id => {
				const user = JSON.parse(localStorage.getItem('me'));
				return {
					url: `/entrevistas-sico/${id}`,
					method: 'PUT',
					body: JSON.stringify({
						data: {
							publishedAt: null,
							updated_by_user: user.id,
						},
					}),
				};
			},
			onQueryStarted: async (arg, { dispatch, queryFulfilled }) => {
				// try catch with antd message when fulfilled and rejected
				try {
					await queryFulfilled;
					message.success('Entrevista Sicológica eliminado exitosamente');
				} catch (error) {
					message.error('Error al eliminar entrevista sicológica');
					if (error.error.data?.error) {
						message.error(error.error.data?.error.message);
					}
				}
			},
			invalidatesTags: (result, error, id) => [
				{ type: 'EntrevistasSico', id },
			],
		}),
	}),
});

export const {
	useGetEntrevistasSicoQuery,
	useGetEntrevistaSicoQuery,
	useAddEntrevistaSicoMutation,
	useUpdateEntrevistaSicoMutation,
	useDeleteEntrevistaSicoMutation,
} = entrevistasSicoApi;
